import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import { SearchBox } from 'react-instantsearch/dom'
import CustomerList from './CustomerList'

class CustomerSelector extends React.PureComponent {

  static propTypes = {
    open: PropTypes.bool,
    anchorElement: PropTypes.shape(),
    onCloseRequest: PropTypes.func,
    onSelection: PropTypes.func,
    addCustomer: PropTypes.func
  }

  constructor(props){
    super(props)
    this.state = {}
  }

  render () {
    if (!this.props.open){
      return null
    }
    return (
      <Popover
        open={this.props.open}
        anchorEl={this.props.anchorElement}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        style={{ borderRadius: 4, width: 290, maxHeight: 240 }}
        useLayerForClickAway={false} // Avoid flashy effect when rendering the popover.
        onRequestClose={this.props.onCloseRequest}>
        <SearchBox
          searchAsYouType={true}
          onReset={this.resetSearch}/>
        <CustomerList
          onSelection={this.props.onSelection}
          addCustomer={this.props.addCustomer}/>
      </Popover>
    )

  }
}

export default CustomerSelector



// WEBPACK FOOTER //
// ./src/customer/CustomerSelector.js